import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Switch,
} from "antd";
import { useEffect, useState } from "react";
import { API } from "../../config/api";
import { GET, POST } from "../../utils/apicalls";
import DatatableMonthlyPlanner from "./datatableMonthlyPlanner";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import CalendarMonthlyPlanner from "./CalendarMonthlyPlanner";
import { useParams } from "react-router-dom";

import moment from "moment";
import PageHeader from "../../admin/pageHeader/pageheader";

function Monthlyplanner() {
  const [page, setPage] = useState(1);
  const [take, setTake] = useState(1000);
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [meta, setMeta] = useState<any>({});
  const [clientData, setClientData] = useState<any>({});
  const [isCalendarView, setIsCalendarView] = useState(false);
  const { id } = useParams();
  const [form] = Form.useForm();
  const sortedData = data?.slice().sort((a: any, b: any) => {
    if (a.date && b.date) {
      return (
        moment(a.date).toDate().getTime() - moment(b.date).toDate().getTime()
      );
    }
    return a.date ? -1 : 1;
  });

  const fetchMonthlyPlanner = async (page: number, take: number) => {
    try {
      setIsLoading(true);
      const obj = {
        query: form.getFieldValue("query"),
        page,
        take,
        clientId: Number(id),
      };
      const url = API.LIST_MONTHLY_PLANNER;
      const response: any = await POST(url, obj);
      setData(response?.data || []);
      setMeta(response?.meta || {});
    } catch (error) {
      console.log("Error fetching monthly planner data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const downloadPDFDocument = () => {
    const doc: any = new jsPDF();
    doc.setFontSize(18);
    doc.text("Monthly Planner", 14, 20);
    doc.setFontSize(14);
    doc.text(clientData.companyName || "Client Name", 14, 30);
    const headers = [["Date", "Content Idea", "Channel", "Content Type"]];
    const rows = sortedData?.map((item: any) => [
      item.date ? moment(item.date).format("DD/MM/YYYY") : "-",
      item.contentIdea || "",
      item.channel || "",
      item.contentType || "",
    ]);
    doc.autoTable({
      head: headers,
      body: rows,
      startY: 40,
      theme: "grid",
      styles: { fontSize: 10 },
    });
    doc.save(`${clientData.companyName}.pdf`);
  };

  useEffect(() => {
    getClientData();
  }, []);

  const getClientData = async () => {
    try {
      const api = `${API.CLIENT_GET_ONE}${id}`;
      const response: any = await GET(api, {});
      setClientData(response?.data || {});
      form.setFieldsValue(response?.data);
    } catch (error) {
      console.log("Error fetching client data:", error);
    }
  };

  useEffect(() => {
    fetchMonthlyPlanner(page, take);
  }, [page, take]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };
  const submitHandler = async (values: any) => {
    try {
      let obj = {
        clientId: id,
        date: values.date,
        contentIdea: values.contentIdea,
        channel: values.channel,
        contentType: values.contentType,
      };

      setIsLoading(true);
      const api = API.CREATE_MONTHLY_PLANNER;
      const postRequest: any = await POST(api, obj);

      if (postRequest.status) {
        notification.success({ message: "planner created successfully!" });
        setIsLoading(false);
        setIsModalOpen(false);
        form.resetFields();
        fetchMonthlyPlanner(page, take);
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };
  const months = [
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const search = async (values: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        clientId: Number(id),
        month: Number(values.month),
      };
      const url = API.SEARCH_MONTHLY_PLANNER;
      const response: any = await POST(url, obj);
      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div>
      <PageHeader>
        <Button
          type="primary"
          onClick={showModal}
          style={{ marginRight: "10px" }}
        >
          Create planner
        </Button>
      </PageHeader>
      <Card>
        <Form form={form} onFinish={search} layout="vertical">
          <Row gutter={16}>
            <Col sm={6}>
              <Form.Item
                label="Month"
                name="month"
                style={{ marginBottom: 10 }}
              >
                <Select placeholder="Select a month" size="large" allowClear>
                  {months.map((month) => (
                    <Select.Option key={month.value} value={month.value}>
                      {month.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  block
                >
                  search
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
      <Card>
        {/* Button to Download PDF Document */}
        <button
          onClick={downloadPDFDocument}
          style={{
            marginBottom: "20px",
            padding: "10px 20px",
            backgroundColor: "#1890ff",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Download Planner as PDF
        </button>

        {/* Toggle between Table and Calendar View */}
        <div style={{ marginBottom: "20px" }}>
          <label style={{ marginRight: "10px" }}>
            Switch to Calendar View:
          </label>
          <Switch checked={isCalendarView} onChange={setIsCalendarView} />
        </div>

        {/* Conditionally Render Table or Calendar View */}
        {isCalendarView ? (
          <CalendarMonthlyPlanner dataSource={data} />
        ) : (
          <DatatableMonthlyPlanner
            dataSource={data}
            isLoading={isLoading}
            meta={meta}
            onPageChange={(page: number, take: number) => {
              setIsLoading(true);
              setPage(page);
              setTake(take);
            }}
          />
        )}
      </Card>

      <Modal
        title="Create Planner"
        visible={isModalOpen}
        onCancel={handleCancel}
        width={1000}
        footer={false}
      >
        <Form form={form} onFinish={submitHandler} layout="vertical">
          <Row gutter={16}>
            <Col sm={6}>
              <Form.Item
                name="contentIdea"
                label=" contentIdea"
                rules={[{ required: true, message: "Enter contentIdea" }]}
              >
                <Input placeholder=" contentIdea" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="channel"
                label="channel"
                rules={[{ required: true, message: "Enter channel" }]}
              >
                <Input placeholder="channel" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="contentType"
                label="contentType"
                rules={[{ required: true, message: "Enter contentType" }]}
              >
                <Input placeholder="contentType" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="date"
                label="date"
                rules={[{ required: true, message: "Select date" }]}
              >
                <DatePicker />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  block
                >
                  Create Planner
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
}

export default Monthlyplanner;
